import FetchWeather from './Componentes/FetchWeather';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className='Content'>
        <FetchWeather />
      </div>
    </div>
  );
}

export default App;
